@if (data(); as d) {
  <header class="page-header">
    <h1>Dashboard</h1>
    <p>Panoramica macchinari e scadenze manutenzione</p>
  </header>

  <section class="stats">
    <article>
      <span class="label">Macchinari</span>
      <strong>{{ d.machines_count }}</strong>
    </article>
    <article class="warn">
      <span class="label">Scadute</span>
      <strong>{{ d.overdue_count }}</strong>
    </article>
    <article>
      <span class="label">Da fare</span>
      <strong>{{ d.pending_count }}</strong>
    </article>
    <article>
      <span class="label">Programmate (7gg)</span>
      <strong>{{ d.scheduled_this_week }}</strong>
    </article>
  </section>

  <section class="alerts-block">
    <div class="section-head">
      <h2>Alert recenti</h2>
      <a routerLink="/alerts">Vedi tutte</a>
    </div>
    @if (d.recent_alerts.length === 0) {
      <p class="empty">Nessun alert al momento.</p>
    } @else {
      <ul class="alert-list">
        @for (a of d.recent_alerts; track a.id) {
          <li>
            <strong>{{ a.machine_name || 'Macchina' }}</strong>
            <span>{{ a.message }}</span>
            <time>{{ a.created_at | date: 'short' }}</time>
          </li>
        }
      </ul>
    }
  </section>
}
